const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList
const SpeechSynthesis = window.speechSynthesis

export const speak = (text, lang = 'pt-BR') => {
  const utterThis = new SpeechSynthesisUtterance(text)
  utterThis.voice = SpeechSynthesis.getVoices().find(v => v.lang === lang)
  utterThis.pitch = 1.0
  utterThis.rate = 1.0
  SpeechSynthesis.speak(utterThis)
}

export const recognition = (callback, lang = 'pt-BR') => {
  const grammar = '#JSGF V1.0; grammar luna; public <luna> = luna ;'

  const recognition = new SpeechRecognition()
  const speechRecognitionList = new SpeechGrammarList()
  speechRecognitionList.addFromString(grammar, 1)

  recognition.grammars = speechRecognitionList
  recognition.lang = lang
  recognition.interimResults = true
  recognition.maxAlternatives = 1

  recognition.start()

  recognition.onresult = function (event) {
    var last = event.results.length - 1
    // var color = event.results[last][0].transcript;
    // diagnostic.textContent = 'Result received: ' + color + '.';
    // bg.style.backgroundColor = color;
    console.log('Results: ', event.results)
    if (event.results[last].isFinal) {
      callback(event.results[last][0].transcript)
    }
    // console.log('Confidence: ' + event.results[0][0].confidence);
  }

  recognition.onspeechend = function () {
    recognition.stop()
  }

  recognition.onnomatch = function (event) {
    speak('Não consegui entender!')
  }

  recognition.onerror = function (event) {
    speak('Tem algo errado comigo. Talvez se você me atualizar, tudo volte ao normal!')
  }
}



// WEBPACK FOOTER //
// ./src/speech.js